import Service from "../../../Service";
import Axios from "../../../Config/API";
import {
    IConfigEnvelopeDocumento,
    IInserirConfigEnvelopeDocumento,
} from "../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDocumento/ConfigEnvelopeDocumentoInterfaces";

export async function GetConfigEnvelopeDocumentoService(
    idConfigEnvelopeDoc: number
) {
    return Service(
        Axios.get<IConfigEnvelopeDocumento>(
            `/home/configenvelope/getconfigenvelopeDoc?idConfigEnvelopeDoc=${idConfigEnvelopeDoc}`
        )
    );
}

export async function ListarConfigEnvelopeDocumentoService(
    idConfigEnvelope: number
) {
    return Service(
        Axios.get<Array<IConfigEnvelopeDocumento>>(
            `/home/configenvelope/listarconfigenvelopeDoc?idConfigEnvelope=${idConfigEnvelope}`
        )
    );
}

export async function InserirConfigEnvelopeDocumentoService(
    configEnvelopeDocumento: IInserirConfigEnvelopeDocumento
) {
    return Service(
        Axios.post(
            `/home/configenvelope/inserirenvelopeconfigDoc`,
            configEnvelopeDocumento
        )
    );
}

export async function DeletarConfigEnvelopeDocumentoService(
    IdConfigEnvelopeDoc: number
) {
    return Service(
        Axios.delete(
            `/home/configenvelope/deletaconfigenvelopeDoc?IdConfigEnvelopeDoc=${IdConfigEnvelopeDoc}`
        )
    );
}

export async function AtualizarConfigEnvelopeDocumentoService(
    configEnvelopeDocumento: IInserirConfigEnvelopeDocumento
) {
    return Service(
        Axios.put(
            `/home/configenvelope/atualizaconfigenvelopeDoc`,
            configEnvelopeDocumento
        )
    );
}
